import { Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { OnyxButtonComponent } from '../../buttons/onyx-button/onyx-button.component';
import type { OnyxLabelLink } from '../../labels/interfaces';
import { OnyxLinkComponent } from '../../links/onyx-link/onyx-link.component';
import type { OnyxEmptyStateAction } from '../interfaces';

@Component({
  selector: 'onyx-empty-state',
  imports: [TranslatePipe, OnyxButtonComponent, OnyxLinkComponent],
  templateUrl: './onyx-empty-state.component.html',
  styleUrl: './onyx-empty-state.component.scss',
})
export class OnyxEmptyStateComponent {
  public readonly heading = input<string>();
  public readonly description = input<string>();
  public readonly link = input<OnyxLabelLink | null>(null);
  public readonly action = input<OnyxEmptyStateAction>();
  public readonly orientation = input<'vertical' | 'horizontal'>('vertical');
  public readonly size = input(72);
  public readonly pulse = input(false);

  protected badgeSize = computed(() =>
    this.orientation() === 'horizontal' ? 40 : this.size(),
  );
}
